"use client"

import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime"
import { useRouter, useSearchParams } from "next/navigation"

export const useAppRouter = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const push: AppRouterInstance['push'] = (href, options) => {
    let _href = `${href}${href.includes('?') ? '&' : '?'}${searchParams.toString()}`
    router.push(
      _href,
      options
    )
  }
  const refresh: AppRouterInstance['refresh'] = (...params) => router.refresh(...params)
  const replace: AppRouterInstance['replace'] = (href, options) => {
    

    let _href = `${href}${href.includes('?') ? '&' : '?'}${searchParams.toString()}`
    router.push(
      _href,
      options
    )
  }

  return {
    ...router,
    push,
    refresh,
    replace
  }
}